import styled from 'styled-components';
import { QuantityButton } from './QuantityButton';

export const QuantityWrapper = styled.div<any>`
  background-color: ${({ isProductDetails }) => {
    if (isProductDetails) return '#43a047';
    return 'transparent';
  }};
  border-radius: ${({ isProductDetails }) => (isProductDetails ? '10px' : '6px')};
  display: flex;
  justify-content: ${({ isProductDetails }) => {
    if (isProductDetails) 'space-between';
    return 'unset';
  }};
  white-space: nowrap;
  padding: ${({ isProductDetails }) => (isProductDetails ? '2px' : '1px')};
  gap: 8px;
  height: ${({ size, isProductDetails }) => (size === 'small' ? (isProductDetails ? '32px' : '30px') : '40px')};
  ${QuantityButton} {
    ${({ isProductDetails }) =>
      !isProductDetails &&
      `
    &.minus {
      border: 1px solid #D5D7D5 !important;
    }
    `}
  }
`;
